import { type TextFieldProps } from '@mui/material/TextField';
import { type FC } from 'react';

import { RHFChipInput } from './rhf-chip-input';
import { LANGUAGE_OPTIONS } from './rhf-language';

type TProps = Omit<TextFieldProps, 'name'> & {
  name: string;
};

export const RHFLanguagesTaughtInput: FC<TProps> = props => (
  <RHFChipInput
    {...props}
    options={LANGUAGE_OPTIONS}
    placeholder={props.placeholder ?? 'Select or type a language and press Enter'}
  />
);
